/* ************************************************************************** */
/*                                Dependencies                                */
/* ************************************************************************** */

// Lib dependencies
import { useNavigate } from 'react-router-dom';

// Store
import useWorkspace from '@features/Workspace/store/hooks/useWorkspace';

/* ************************************************************************** */
/*                                    Hook                                    */
/* ************************************************************************** */

function useRefetchQuestions() {
  const navigate = useNavigate();
  const workspace = useWorkspace();

  function refetchQuestions() {
    navigate(`/workspace/${workspace.id}/support?refetch=true`);
  }

  return refetchQuestions;
}

export default useRefetchQuestions;
